module.exports = __webpack_public_path__ + "static/media/rmI.a68662e1.png";